/* eslint-disable */
// @ts-nocheck
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";

export default function OrgFormDialog(props: any) {
  const {
    openModal,
    handleCloseModal,
    editData,
    organisation,
    setOrganisation,
    handleChange,
    orgValidationErrors,
    handleSubmit,
    isGlobalAdmin,
    organisationList = [],
  } = props;

  return (
    <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
      <DialogTitle>
        {editData ? "Edit Organisation" : "Add Organisation"}
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={organisation.name}
              onChange={handleChange}
              error={!!orgValidationErrors.name}
              helperText={orgValidationErrors.name}
              margin="normal"
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="ABN"
              name="abn"
              value={organisation.abn}
              onChange={handleChange}
              error={!!orgValidationErrors.abn}
              helperText={orgValidationErrors.abn}
              margin="normal"
              inputProps={{ maxLength: 11 }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Australian Financial Services License Number"
              name="afslNumber"
              value={organisation.afslNumber}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Website"
              name="website"
              value={organisation.website}
              onChange={handleChange}
              error={!!orgValidationErrors.website}
              helperText={
                orgValidationErrors.website ||
                "e.g. www.example.com or https://example.com"
              }
              margin="normal"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Billing Contact Name"
              name="billingContactName"
              value={organisation.billingContactName}
              onChange={handleChange}
              error={!!orgValidationErrors.billingContactName}
              helperText={orgValidationErrors.billingContactName}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Billing Contact Email"
              name="billingContactEmail"
              value={organisation.billingContactEmail}
              onChange={handleChange}
              error={!!orgValidationErrors.billingContactEmail}
              helperText={orgValidationErrors.billingContactEmail}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Billing Contact Phone"
              name="billingContactPhone"
              value={organisation.billingContactPhone}
              onChange={handleChange}
              error={!!orgValidationErrors.billingContactPhone}
              helperText={orgValidationErrors.billingContactPhone}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Billing Contact Mobile"
              name="billingContactMobile"
              value={organisation.billingContactMobile}
              onChange={handleChange}
              error={!!orgValidationErrors.billingContactMobile}
              helperText={orgValidationErrors.billingContactMobile}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <TextField
              fullWidth
              label="Billing Address"
              name="billingAddress"
              value={organisation.billingAddress.line1}
              onChange={(e) => {
                setOrganisation((prev) => ({
                  ...prev,
                  billingAddress: {
                    ...prev.billingAddress,
                    line1: e.target.value,
                  },
                }));
              }}
              error={!!orgValidationErrors.billingAddress}
              helperText={orgValidationErrors.billingAddress}
              margin="normal"
            />
          </Grid>

          <Grid item xs={12}>
            {isGlobalAdmin && (
              <TextField
                fullWidth
                select
                label="Parent organisation"
                name="parentOrganisationId"
                value={organisation.parentOrganisationId || ""}
                onChange={handleChange}
                helperText="Leave empty for a standalone/parent organisation. Select a parent to create a child tenant."
                margin="normal"
              >
                <MenuItem value="">No parent (top-level)</MenuItem>
                {organisationList
                  .filter((candidate: any) =>
                    candidate._id !== editData?._id &&
                    !candidate.parentOrganisationId &&
                    candidate.hierarchyRole !== "child"
                  )
                  .map((candidate: any) => (
                    <MenuItem key={candidate._id} value={candidate._id}>
                      {candidate.name}
                    </MenuItem>
                  ))}
              </TextField>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Status"
              name="status"
              value={organisation.status}
              onChange={handleChange}
              margin="normal"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            {openModal && (
              <Box display="flex" alignItems="center">
                {isGlobalAdmin && (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={organisation.isBillingExempt}
                        onChange={(e) =>
                          setOrganisation((prev) => ({
                            ...prev,
                            isBillingExempt: e.target.checked,
                          }))
                        }
                        color="primary"
                      />
                    }
                    label="Billing Exempt (Dev/Partner)"
                  />
                )}
                <FormControlLabel
                  control={
                    <Switch
                      checked={organisation.twoFactorEnabled}
                      onChange={(e) =>
                        handleChange({
                          target: {
                            name: "twoFactorEnabled",
                            value: e.target.checked,
                          },
                        })
                      }
                      color="primary"
                    />
                  }
                  label="Enable Two-Factor Authentication (2FA)"
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          {editData ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
